import { updateUserSettings as _updateUserSettings } from '@griply/services';
import { type UserSettings } from '@griply/types';
import { serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore';

import { getUser } from './get-user';
import { doc, getDatabase } from './helpers';

export const updateUserSettings = async (
  userSettings: Partial<UserSettings>,
): Promise<void> => {
  const user = await getUser();
  if (!user) {
    return;
  }

  const db = getDatabase();

  await _updateUserSettings({
    userSettings,
    userId: user.uid,
    doc,
    updateDoc,
    db,
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
  });
};
